module.exports = __webpack_public_path__ + "img/login_page_sidepanel.eb1f680a.png";